import {
    type ApiEndpoint,
    type DownloadUrlResponse,
    isDownloadUrlResponse,
} from "@/shared/api-endpoint";
import { isObject } from "@/shared/utils/typeGuards";

export const kInpainting40Route = "/inpainting-4.0";

export interface Inpainting40RequestBody {
    fileKey: string;
    bpm: number;
    complexity?: number;
    inpaintMaskStartSeconds?: number;
    inpaintMaskEndSeconds?: number;
    seed?: number;
    secondsEnd?: number;
}

export const isInpainting40RequestBody = (value: unknown): value is Inpainting40RequestBody =>
    isObject(value) && typeof value.fileKey === "string" && typeof value.bpm === "number";

export const kInpainting40Endpoint: ApiEndpoint<Inpainting40RequestBody, DownloadUrlResponse> = {
    route: kInpainting40Route,
    label: "Inpainting 4.0",
    source: "Modal",
    isEvaluationOnly: true,
    category: "SpliceGen v4.0",
    description:
        "Regenerates a masked time range of an audio loop while preserving the surrounding audio, using the SpliceGen 4.0 inpainting model.",
    isRequestBody: isInpainting40RequestBody,
    isSuccessResponse: isDownloadUrlResponse,
};
